module.exports = __webpack_public_path__ + "static/media/account.4fa4d85d.svg";